"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeThemeHeader = ChangeThemeHeader;
exports.ChangeThemeForm = ChangeThemeForm;
exports.default = ChangeTheme;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const react_i18next_1 = require("react-i18next");
const Theme_1 = require("../Theme");
const Button_1 = __importDefault(require("../components/Button"));
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        topCard: {
            padding: 12,
            borderRadius: 14,
            backgroundColor: THEME.Surface,
            borderWidth: 1,
            borderColor: THEME.LightGray,
        },
        title: {
            color: THEME.Text,
            fontWeight: "700",
            fontSize: size != 'sm' ? 16 : 15,
        },
        subtitle: {
            marginTop: 6,
            color: THEME.OnSurfaceVariant ?? THEME.Text,
            opacity: 0.75,
            fontSize: 12,
        },
        option: {
            padding: 0,
            marginBottom: 10,
            borderRadius: 14,
            borderWidth: 1,
            borderColor: THEME.LightGray,
            backgroundColor: THEME.Surface,
            overflow: "hidden"
        },
        optionSelected: {
            borderColor: THEME.Primary,
            backgroundColor: THEME.PrimaryContainer,
        },
        optionInner: {
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: "center",
            paddingVertical: 12,
            paddingHorizontal: 12,
            gap: 10,
        },
        iconWrap: {
            width: 36,
            height: 36,
            borderRadius: 10,
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: THEME.UltraLightGray,
            borderWidth: 1,
            borderColor: THEME.LightGray,
        },
        optionTitle: {
            color: THEME.Text,
            fontWeight: "700",
            fontSize: 14,
        },
        optionSubtitle: {
            marginTop: 2,
            color: THEME.OnSurfaceVariant,
            opacity: 0.75,
            fontSize: 12,
        },
        radioOuter: {
            width: 20,
            height: 20,
            borderRadius: 10,
            borderWidth: 2,
            alignItems: "center",
            justifyContent: "center",
        },
        radioInner: {
            width: 10,
            height: 10,
            borderRadius: 5,
        }
    });
};
function ChangeThemeHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.CircleHalfStroke, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: '500', fontSize: (size != 'sm' ? 18 : 16), marginLeft: 8 }, children: t('common:appmenus.changeTheme') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: "borderless", onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
;
function ChangeThemeForm(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const appTheme = (0, ThemeContext_1.useAppTheme)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const [selectedMode, setSelectedMode] = react_1.default.useState(appTheme.mode ?? "system");
    const save = async () => {
        await appTheme.setMode(selectedMode);
        props.onSaved?.();
    };
    const options = [
        {
            key: "system",
            title: t("common:themes.system"),
            subtitle: t("common:themes.systemDesc"),
            icon: Theme_1.ICONS.Solid.Desktop,
        },
        {
            key: "light",
            title: t("common:themes.light"),
            subtitle: t("common:themes.lightDesc"),
            icon: Theme_1.ICONS.Solid.Sun,
        },
        {
            key: "dark",
            title: t("common:themes.dark"),
            subtitle: t("common:themes.darkDesc"),
            icon: Theme_1.ICONS.Solid.Moon,
        },
    ];
    const isSelected = (k) => selectedMode === k;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginTop: 12 }, children: options.map((opt) => ((0, jsx_runtime_1.jsx)(Button_1.default, { type: "borderless", onPress: () => setSelectedMode(opt.key), style: [
                        styles.option,
                        isSelected(opt.key) && styles.optionSelected,
                    ], children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.optionInner, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.iconWrap, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: opt.icon, size: 18, color: THEME.Text }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.optionTitle, children: opt.title }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.optionSubtitle, children: opt.subtitle })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [
                                    styles.radioOuter,
                                    { borderColor: isSelected(opt.key) ? THEME.Primary : THEME.TextDisabled },
                                ], children: isSelected(opt.key) ? ((0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.radioInner, { backgroundColor: THEME.Primary }] })) : null })] }) }, opt.key))) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: "row", marginTop: 16, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", extraPadding: 4, text: t("common:buttons.cancel"), onPress: props.onCancel }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { extraPadding: 4, text: t("common:buttons.save"), onPress: save }) })] })] }));
}
function ChangeTheme(props) {
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 2 }, children: (0, jsx_runtime_1.jsx)(ChangeThemeHeader, { onClose: props.onClose ?? props.navigation.goBack }) }), (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, keyboardShouldPersistTaps: "handled", children: (0, jsx_runtime_1.jsx)(ChangeThemeForm, { onCancel: props.onClose ?? props.navigation.goBack, onSaved: props.onSave ?? props.navigation.goBack }) })] }));
}
;
